import { offMarketStatusCodes } from 'constants/listings/statusCodes';

export const isListingOffMarket = (statusCode: string): boolean =>
  offMarketStatusCodes.includes(statusCode);
